<div>
    <button
        (click)="activeModal.dismiss('Cross click')"
        aria-label="Close"
        class="close"
        data-dismiss="modal"
        type="button"
    >
        <i class="pbslm-close-thin-cross close-img"></i>
    </button>
</div>
<div class="modal-body gtm-lti-continue-modal">
    <div class="title modal-title-text">Interactive Lesson Sign In</div>
    <div class="advice modal-body-text">
        Sign in to your PBS LearningMedia account to save your progress and submit your work. You
        can continue as a guest, but you won’t be able to save your progress or submit your work.
    </div>
    <div class="buttons-wrapper mt-4 d-flex justify-content-end">
        <button
            type="button"
            class="continue-as selenium-lti-continue-as-guest gtm-lti-continue-as-guest btn btn-outline-secondary me-2"
            (click)="goToLTIAsGuest()"
        >
            Continue as a Guest
        </button>
        <button
            type="button"
            class="sign-in selenium-lti-login gtm-lti-login btn btn-outline-primary ms-2 me-0"
            (click)="openLTILoginModal()"
        >
            Sign In
        </button>
    </div>
</div>
